export const CONSTANT = {
    baseUrl: '/',
    timeout: 30000
};

export const CONTACT_INFO = {
    email: 'info@blueskymls.com',
    phone: '+1-800-23-BLUE-SKY'
};

export const USD_WITH_DECIMAL_ATTR = {
    prefix: '$',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    allowLeadingZeroes: true
};

export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const FILING_STATUS = {
    NOT_FILED: 0,
    PENDING: 1,
    APPROVED: 2,
    DENIED: 3,
    IN_PROGRESS: 4,
    ON_HOLD: 5,
    CLIENT_CANCELLED: 6,
    EXEMPTION_APPROVED: 7,
    EXEMPTION_QUERIED: 8,
    AMENDMENT: 9,
    HOLD_FOR_PAYMENT: 10,
    READY_FOR_RENEWAL: 11,
    TERMINATED: 12,
    FILING_SENT: 13
};

export const ELECTRONIC_FILING_STATUS = {
    NOT_SUBMITTED: 0,
    SUCCESS: 1,
    FAILED: 2
};

export const FILEABLE_STATUSES = [
    FILING_STATUS.NOT_FILED,
    FILING_STATUS.CLIENT_CANCELLED,
    FILING_STATUS.EXEMPTION_QUERIED,
    FILING_STATUS.TERMINATED
];

export const FUND_FILING_TYPE = {
    UNKNOWN: 0,
    TRUST: 1,
    PORTFOLIO: 2,
    CLASS: 3,
    PROSPECTUS: 4,
    NOT_REQUIRED: 5
};

export const FILING_PRIORITY = {
    PRIORITY_WITH_EXEMPTIONS: 1,
    FILE_WITH_PRIORITY: 2,
    NON_PRIORITY: 3
};

export const STATES = [
    {
        stateId: 0,
        name: '',
        code: ''
    },
    {
        stateId: 1,
        name: 'Alabama',
        code: 'AL'
    },
    {
        stateId: 2,
        name: 'Alaska',
        code: 'AK'
    },
    {
        stateId: 3,
        name: 'Arizona',
        code: 'AZ'
    },
    {
        stateId: 4,
        name: 'Arkansas',
        code: 'AR'
    },
    {
        stateId: 5,
        name: 'California',
        code: 'CA'
    },
    {
        stateId: 6,
        name: 'Colorado',
        code: 'CO'
    },
    {
        stateId: 7,
        name: 'Connecticut',
        code: 'CT'
    },
    {
        stateId: 8,
        name: 'Delaware',
        code: 'DE'
    },
    {
        stateId: 9,
        name: 'Florida',
        code: 'FL'
    },
    {
        stateId: 10,
        name: 'Georgia',
        code: 'GA'
    },
    {
        stateId: 11,
        name: 'Hawaii',
        code: 'HI'
    },
    {
        stateId: 12,
        name: 'Idaho',
        code: 'ID'
    },
    {
        stateId: 13,
        name: 'Illinois',
        code: 'IL'
    },
    {
        stateId: 14,
        name: 'Indiana',
        code: 'IN'
    },
    {
        stateId: 15,
        name: 'Iowa',
        code: 'IA'
    },
    {
        stateId: 16,
        name: 'Kansas',
        code: 'KS'
    },
    {
        stateId: 17,
        name: 'Kentucky',
        code: 'KY'
    },
    {
        stateId: 18,
        name: 'Louisiana',
        code: 'LA'
    },
    {
        stateId: 19,
        name: 'Maine',
        code: 'ME'
    },
    {
        stateId: 20,
        name: 'Maryland',
        code: 'MD'
    },
    {
        stateId: 21,
        name: 'Massachusetts',
        code: 'MA'
    },
    {
        stateId: 22,
        name: 'Michigan',
        code: 'MI'
    },
    {
        stateId: 23,
        name: 'Minnesota',
        code: 'MN'
    },
    {
        stateId: 24,
        name: 'Mississippi',
        code: 'MS'
    },
    {
        stateId: 25,
        name: 'Missouri',
        code: 'MO'
    },
    {
        stateId: 26,
        name: 'Montana',
        code: 'MT'
    },
    {
        stateId: 27,
        name: 'Nebraska',
        code: 'NE'
    },
    {
        stateId: 28,
        name: 'Nevada',
        code: 'NV'
    },
    {
        stateId: 29,
        name: 'New Hampshire',
        code: 'NH'
    },
    {
        stateId: 30,
        name: 'New Jersey',
        code: 'NJ'
    },
    {
        stateId: 31,
        name: 'New Mexico',
        code: 'NM'
    },
    {
        stateId: 32,
        name: 'New York',
        code: 'NY'
    },
    {
        stateId: 33,
        name: 'North Carolina',
        code: 'NC'
    },
    {
        stateId: 34,
        name: 'North Dakota',
        code: 'ND'
    },
    {
        stateId: 35,
        name: 'Ohio',
        code: 'OH'
    },
    {
        stateId: 36,
        name: 'Oklahoma',
        code: 'OK'
    },
    {
        stateId: 37,
        name: 'Oregon',
        code: 'OR'
    },
    {
        stateId: 38,
        name: 'Pennsylvania',
        code: 'PA'
    },
    {
        stateId: 39,
        name: 'Rhode Island',
        code: 'RI'
    },
    {
        stateId: 40,
        name: 'South Carolina',
        code: 'SC'
    },
    {
        stateId: 41,
        name: 'South Dakota',
        code: 'SD'
    },
    {
        stateId: 42,
        name: 'Tennessee',
        code: 'TN'
    },
    {
        stateId: 43,
        name: 'Texas',
        code: 'TX'
    },
    {
        stateId: 44,
        name: 'Utah',
        code: 'UT'
    },
    {
        stateId: 45,
        name: 'Vermont',
        code: 'VT'
    },
    {
        stateId: 46,
        name: 'Virginia',
        code: 'VA'
    },
    {
        stateId: 47,
        name: 'Washington',
        code: 'WA'
    },
    {
        stateId: 48,
        name: 'Washington DC',
        code: 'DC'
    },
    {
        stateId: 49,
        name: 'West Virginia',
        code: 'WV'
    },
    {
        stateId: 50,
        name: 'Wisconsin',
        code: 'WI'
    },
    {
        stateId: 51,
        name: 'Wyoming',
        code: 'WY'
    },
    {
        stateId: 52,
        name: 'American Samoa',
        code: 'AS'
    },
    {
        stateId: 53,
        name: 'Armed Forces Americas',
        code: 'AA'
    },
    {
        stateId: 54,
        name: 'Armed Forces Europe',
        code: 'AE'
    },
    {
        stateId: 55,
        name: 'Guam',
        code: 'GU'
    },
    {
        stateId: 56,
        name: 'Northern Mariana Islands',
        code: 'MP'
    },
    {
        stateId: 57,
        name: 'Puerto Rico',
        code: 'PR'
    },
    {
        stateId: 58,
        name: 'U.S. Virgin Islands',
        code: 'VI'
    }
];



// WEBPACK FOOTER //
// ./src/services/constant/constant.js